// Admin permissions
export const RESET_PASSWORD_PERM = "RESET_PASSWORD_PERM";
export const VIEW_GATES_PAGE_PERM = "VIEW_GATES_LIST_PERM";
export const LOGGING_AS_USER_PERM = "LOGGING_AS_USER_PERM";

// Main permissions
export const VIEW_REPORTS_PAGE_PERM = "VIEW_REPORTS_PAGE_PERM";
export const VIEW_CONVERSIONS_PAGE_PERM = "VIEW_CONVERSIONS_PAGE_PERM";
export const VIEW_ASSISTED_REPORT_PAGE_PERM = "VIEW_ASSISTED_REPORT_PAGE_PERM";

export const VIEW_AIRLINES_PAGE_PERM = "VIEW_AIRLINES_PAGE_PERM";
export const VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM = "VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM";

export const VIEW_DASHBOARD_PAGE_PERM = "VIEW_DASHBOARD_PAGE_PERM";
export const VIEW_HOSTS_PAGE_PERM = "VIEW_HOSTS_PAGE_PERM";
export const VIEW_CLICKS_PAGE_PERM = "VIEW_CLICKS_PAGE_PERM";
export const VIEW_BOOKINGS_PAGE_PERM = "VIEW_BOOKINGS_PAGE_PERM";
export const VIEW_DIRECTIONS_PAGE_PERM = "VIEW_DIRECTIONS_PAGE_PERM";
export const VIEW_AUCTION_PAGE_PERM = "VIEW_AUCTION_PAGE_PERM";
export const VIEW_ERRORS_PAGE_PERM = "VIEW_ERRORS_PAGE_PERM";

// Other permissions
export const VIEW_FAQ_PAGE_PERM = "VIEW_FAQ_PAGE_PERM";
export const VIEW_FEEDBACKS_PAGE_PERM = "VIEW_FEEDBACKS_PAGE_PERM";
export const VIEW_DEBUG_PAGE_PERM = "VIEW_DEBUG_PAGE_PERM";
export const VIEW_GATE_TESTER_PAGE_PERM = "VIEW_GATE_TESTER_PAGE_PERM";
export const VIEW_CONTACT_US_PAGE_PERM = "VIEW_CONTACT_US_PAGE_PERM";
export const VIEW_ALERTS_PAGE_PERM = "VIEW_ALERTS_PAGE_PERM";
